import abi from "./Nestcoin.json";

export const contractAddressT = "0x33d57e4712e4c4Dc6ff50e3319E1e79D7eABC937";
export const contractABIT = abi.abi;
